import React from "react";
import clsx from "clsx";

import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import { FacilityData, APPS } from "../constants";
import TrackIcon from "./TrackIcon";

import useStyles from "./styles";

interface Props {
  facilityData: FacilityData;
  setSelectedFacility: (id: string) => void;
  setCurrentActiveApp: (appName: APPS) => void;
  onSlideChange?: (appName: APPS) => void;
}

const FacilitySelector = (props: Props) => {
  const {
    facilityData,
    setSelectedFacility,
    setCurrentActiveApp,
    onSlideChange
  } = props;

  const classes = useStyles();

  const handleClickFacilityItem = (id: string) => {
    setSelectedFacility(id);
    setCurrentActiveApp(APPS.ApplicationSelector);
    onSlideChange(APPS.ApplicationSelector);
  };

  const renderByPartSign = (sign: string) => {
    return Object.keys(facilityData)
      .map((facilityDataItem, index) => {
        if (sign === "odd" && index % 2 !== 0) {
          return null;
        }
        if (sign === "even" && index % 2 === 0) {
          return null;
        }

        return (
          <div
            className={classes.facilityItem}
            key={facilityData[facilityDataItem].id}
            onClick={() =>
              handleClickFacilityItem(facilityData[facilityDataItem].id)
            }
          >
            <TrackIcon facility={facilityData[facilityDataItem]} />
            <div className={classes.facilityContentContainer}>
              <div className={clsx(classes.facilityName, classes.capitalize)}>
                {facilityData[facilityDataItem].name.toLowerCase()}
              </div>
              <ArrowForwardIosIcon className={classes.openAppIcon} />
            </div>
          </div>
        );
      })
      .filter(Boolean);
  };

  return (
    <>
      <div className={classes.selectFacilityList}>
        <div className={classes.selectFacilityListLeft}>
          {renderByPartSign("odd")}
        </div>
        <div className={classes.selectFacilityListRight}>
          {renderByPartSign("even")}
        </div>
      </div>
    </>
  );
};

export default FacilitySelector;
